import replaceLast from '../utils/replace-last';
import placeholder from './img_placeholder.png';
import { withApplicationUrl } from '../utils/with-application-url';

export default function (url) {
  let image = replaceLast(url, '.jpg', '_small.jpg');
  image = replaceLast(image, '.png', '_small.png');
  return image || withApplicationUrl(placeholder);
}
